import { createContext } from 'react';

export type OnboardingContextProps = {};

export const OnboardingContext = createContext<OnboardingContextProps>({});
